import { uniqueId } from 'lodash-unified';
import { PLAYER_INACTIVITY_TIME } from '@bg-shared/constants/constants';
import { playerActivityStore } from './PlayerActivity.store';

class PlayerActivityService {
    private timeout: number;

    public runTimeout(): void {
        this.timeout = setTimeout(() => {
            playerActivityStore.update({ inactive: true, identity: '0' });
        }, PLAYER_INACTIVITY_TIME);
    }

    public clearTimeout(): void {
        clearTimeout(this.timeout);
    }

    public reset(): void {
        clearTimeout(this.timeout);
        playerActivityStore.update({ inactive: false, identity: uniqueId() });
    }
}

export const playerActivityService = new PlayerActivityService();
